<script setup></script>

<template>
  <FormKit
    v-bind="$attrs"
    :input-class="({ hasErrors }) => (hasErrors ? 'error' : '')"
  >
    <template #label="labelSlotProps">
      <slot name="label" v-bind="labelSlotProps">
        <label :for="labelSlotProps.id">
          {{ labelSlotProps.label }}
          <span
            v-for="error in labelSlotProps.visibleValidationErrors"
            :key="error"
            class="error"
            >• Error: {{ error }}</span
          ></label
        ></slot
      >
    </template>
    <template #errors><ul></ul></template>
  </FormKit>
</template>
